(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const openPreferences = async () => {
      const timeoutAt = Date.now() + 5000;
      while (Date.now() < timeoutAt) {
        if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
          await window.privacyBanner.showPreferences();
          return;
        }
        await new Promise((resolve) => window.setTimeout(resolve, 100));
      }
      window.location.assign('/policies/privacy-policy');
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-vera-cookie-preferences]');
      if (!trigger) return;
      event.preventDefault();
      openPreferences().catch(() => window.location.assign('/policies/privacy-policy'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vera-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.veraEditionReady === 'true') return;
      const tabs = [...root.querySelectorAll('[data-vera-edition]')];
      const frames = [...root.querySelectorAll('[data-vera-frame]')];
      const count = root.querySelector('.vera-editorial__count');
      if (tabs.length < 2 || frames.length < 2) return;

      const select = (index) => {
        tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');
        });
        frames.forEach((frame, frameIndex) => frame.classList.toggle('is-active', frameIndex === index));
        if (count) count.textContent = `0${index + 1} / 0${frames.length}`;
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const next = event.key === 'ArrowRight' ? (index + 1) % tabs.length : (index - 1 + tabs.length) % tabs.length;
          select(next);
          tabs[next].focus();
        });
      });
      root.dataset.veraEditionReady = 'true';
    };

    document.querySelectorAll('.vera-editorial--home-space').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('.vera-editorial--home-space')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vera-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const media = document.querySelector('.vera-homepage .vera-hero__media');
    if (!media) return;
    const updateHeader = () => document.body.classList.toggle('vera-home-scrolled', media.getBoundingClientRect().bottom <= 72);
    window.addEventListener('scroll', updateHeader, { passive: true });
    window.addEventListener('resize', updateHeader);
    updateHeader();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vera-product-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vera-sticky-buy]').forEach((bar) => {
    const product = bar.closest('product-component');
    const mainButton = product?.querySelector('.vera-product__info .vera-product__submit');
    if (!mainButton || bar.dataset.ready) return;
    bar.dataset.ready = 'true';
    const update = () => {
      const passed = mainButton.getBoundingClientRect().bottom < 0;
      const drawerOpen = Boolean(document.querySelector('cart-drawer.active, .drawer.active, dialog[open]'));
      const menuOpen = Boolean(document.querySelector('menu-drawer details[open], header-drawer details[open]'));
      const cookieOpen = Boolean(document.querySelector('#shopify-pc__banner:not([hidden]), .shopify-pc__banner:not([hidden]), #shopify-pc__prefs__dialog[open]'));
      const closingSection = document.querySelector('.vera-section--charcoal');
      const footer = document.querySelector('footer');
      const atClosingSection = Boolean(closingSection && closingSection.getBoundingClientRect().top < window.innerHeight);
      const atFooter = Boolean(footer && footer.getBoundingClientRect().top < window.innerHeight);
      const focusedField = document.activeElement?.matches('input, textarea, select');
      bar.classList.toggle('is-visible', passed && !drawerOpen && !menuOpen && !cookieOpen && !atClosingSection && !atFooter && !focusedField);
    };
    window.addEventListener('scroll', update, { passive: true });
    document.addEventListener('focusin', update);
    document.addEventListener('focusout', update);
    new MutationObserver(update).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class', 'open'] });
    update();
  });

  if (!customElements.get('vera-gallery')) {
    customElements.define('vera-gallery', class VeraGallery extends HTMLElement {
      connectedCallback() {
        this.classList.add('is-ready');
        this.slides = Array.from(this.querySelectorAll('[data-vera-gallery-slide]'));
        this.buttons = Array.from(this.querySelectorAll('[data-vera-gallery-button]'));
        this.current = this.querySelector('[data-vera-gallery-current]');
        this.track = this.querySelector('.vera-gallery__track');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.activeIndex = 0;
        this.onBreakpoint = () => {
          if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = null;
          if (this.mobile.matches) this.track.scrollTo({ left: this.slides[this.activeIndex].offsetLeft, behavior: 'instant' });
          this.select(this.activeIndex, false);
          this.syncHeight();
        };
        this.mobile.addEventListener('change', this.onBreakpoint);
        this.buttons.forEach((button) => { button.addEventListener('click', () => this.select(Number(button.dataset.index), true)); button.addEventListener('keydown', (event) => this.onKeydown(event)); });
        this.querySelector('[data-vera-gallery-previous]')?.addEventListener('click', () => this.select(this.activeIndex - 1, true));
        this.querySelector('[data-vera-gallery-next]')?.addEventListener('click', () => this.select(this.activeIndex + 1, true));
        this.track?.addEventListener('scroll', () => this.onScroll(), { passive: true });
        this.querySelectorAll('img').forEach((image) => {
          if (!image.complete) image.addEventListener('load', () => this.syncHeight(), { once: true });
        });
        this.resizeObserver = new ResizeObserver(() => this.syncHeight());
        this.slides.forEach((slide) => this.resizeObserver.observe(slide));
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.pauseVideos(); });
        this.select(0, false);
      }
      disconnectedCallback() { this.mobile?.removeEventListener('change', this.onBreakpoint); this.resizeObserver?.disconnect(); if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame); }
      syncHeight() {
        if (!this.track) return;
        if (!this.mobile.matches) {
          this.track.style.height = '';
          return;
        }
        const selected = this.slides[this.activeIndex];
        if (selected) this.track.style.height = `${selected.offsetHeight}px`;
      }
      pauseVideos() { this.querySelectorAll('video').forEach((video) => video.pause()); }
      select(index, move) {
        const boundedIndex = Math.max(0, Math.min(index, this.slides.length - 1));
        if (boundedIndex !== this.activeIndex) this.pauseVideos();
        this.activeIndex = boundedIndex;
        this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === boundedIndex));
        this.buttons.forEach((button, i) => { button.classList.toggle('is-active', i === boundedIndex); if (i === boundedIndex) button.setAttribute('aria-current', 'true'); else button.removeAttribute('aria-current'); });
        if (this.current) this.current.textContent = String(boundedIndex + 1);
        const selected = this.buttons[boundedIndex];
        const thumbs = selected.parentElement;
        const thumbLeft = selected.offsetLeft - thumbs.offsetLeft;
        if (thumbLeft < thumbs.scrollLeft || thumbLeft + selected.offsetWidth > thumbs.scrollLeft + thumbs.clientWidth) thumbs.scrollTo({ left: Math.max(0, thumbLeft - thumbs.clientWidth / 2 + selected.offsetWidth / 2), behavior: 'instant' });
        this.querySelector('[data-vera-gallery-previous]').disabled = boundedIndex === 0;
        this.querySelector('[data-vera-gallery-next]').disabled = boundedIndex === this.slides.length - 1;
        if (move && this.mobile.matches) this.track.scrollTo({ left: this.slides[boundedIndex].offsetLeft, behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
        this.syncHeight();
      }
      onKeydown(event) {
        const currentIndex = Number(event.currentTarget.dataset.index); let nextIndex = currentIndex;
        if (event.key === 'ArrowRight') nextIndex = Math.min(currentIndex + 1, this.buttons.length - 1); else if (event.key === 'ArrowLeft') nextIndex = Math.max(currentIndex - 1, 0); else if (event.key === 'Home') nextIndex = 0; else if (event.key === 'End') nextIndex = this.buttons.length - 1; else return;
        event.preventDefault(); this.select(nextIndex, true); this.buttons[nextIndex].focus();
      }
      onScroll() {
        if (!this.mobile.matches || this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => { const left = this.track.scrollLeft; let nearestIndex = 0; let nearestDistance = Infinity; this.slides.forEach((slide, i) => { const distance = Math.abs(slide.offsetLeft - left); if (distance < nearestDistance) { nearestDistance = distance; nearestIndex = i; } }); this.select(nearestIndex, false); this.scrollFrame = null; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
